import { useMemo } from "react";

/** HP notification red (Figma). */
export const HP_NOTIFICATION_RED = "#CC2C00";

/**
 * Mirrors the dot drawn inside the HP header icons (see HpNotificationsIcon): an 8px
 * #CC2C00 circle centred 12px from the top and side of the 38px icon button. Applied to
 * MUI Badge indicators in the header so every dot sits in the same place.
 */
export const HP_HEADER_DOT_BADGE_SX = {
  "& .MuiBadge-badge": {
    backgroundColor: HP_NOTIFICATION_RED,
    width: 8,
    height: 8,
    minWidth: 8,
    borderRadius: "50%",
    top: 12,
    right: 12,
  },
};

const useStyle = () => {
  const classes = useMemo(() => {
    return {
      // HP Client header container - matches Figma design
      headerContainer: {
        display: "flex",
        flexDirection: "row" as "row",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "0px 24px",
        width: "100%",
        height: "56px",
        background: "#FFFFFF",
        borderBottom: "1px solid #E0E0E0",
        borderRadius: 0,
      },
      // Left side container with trial indicator
      leftContainer: {
        display: "flex",
        alignItems: "center",
        gap: "16px",
        width: "100%",
      },
      // Icon button style - circular gray background
      iconButton: {
        display: "flex",
        flexDirection: "row" as "row",
        justifyContent: "center",
        alignItems: "center",
        padding: 0,
        width: "32px",
        height: "32px",
        background: "#E0E0E0",
        borderRadius: "50%",
        border: "none",
        cursor: "pointer",
      },
      // Support icon button with badge
      supportIconButton: {
        display: "flex",
        flexDirection: "row" as "row",
        justifyContent: "center",
        alignItems: "center",
        padding: 0,
        width: "32px",
        height: "32px",
        background: "#E0E0E0",
        borderRadius: "50%",
        border: "none",
        cursor: "pointer",
      },
      // Badge style for notifications
      notificationBadge: {
        fontSize: "0.7rem",
        height: 18,
        minWidth: 18,
        right: 4,
        top: 4,
        backgroundColor: HP_NOTIFICATION_RED,
      },
    };
  }, []);

  return {
    classes,
  };
};

export { useStyle };
